module.exports = __webpack_public_path__ + "media/images/image7-3a0748b5f1d28f5e3adc50905f4b90e3.png";